export const equipList = [
  {
    id: "pole",
    type: "equip-pole",
  },
  {
    id: "cable",
    type: "equip-cable",
  },
  {
    id: "relay",
    type: "equip-relay",
  },
  {
    id: "transformer",
    type: "equip-transformer",
  },
  {
    id: "switch",
    type: "equip-switch",
  },
  {
    id: "meter",
    type: "equip-meter",
  },
  {
    id: "riserTransformer",
    type: "equip-riser-transformer",
  },
];

export const workFuncList = [
  {
    value: "IN.",
    label: "IN.",
  },
  {
    value: "RM.",
    label: "RM.",
  },
  {
    value: "RP.",
    label: "RP.",
  },
  {
    value: "EX.",
    label: "EX.",
  },
];

export const PoleSizeList = [
  {
    value: 6,
    label: "6",
  },
  {
    value: 8.5,
    label: "8.5",
  },
  {
    value: 10,
    label: "10",
  },
  {
    value: 12,
    label: "12",
  },
  {
    value: 14,
    label: "14",
  },
];

export const LampPowerList = [
  {
    value: 80,
    label: "80W",
  },
  {
    value: 125,
    label: "125W",
  },
  {
    value: 150,
    label: "150W",
  },
  {
    value: 250,
    label: "250W",
  },
  {
    value: 400,
    label: "400W",
  },
];

export const CableTypeList = [
  {
    value: "aerial",
    label: "สายตีเกลียว",
  },
  {
    value: "onPole",
    label: "สายไฟแรงต่ำ AW บนเสา",
  },
  {
    value: "mediumVoltageCable",
    label: "สายไฟแรงกลาง",
  },
  {
    value: "underAwning",
    label: "สายไฟแรงต่ำ AW ใต้กันสาด",
  },
  {
    value: "public",
    label: "สายไฟสาธารณะ",
  },
];

export const CableAerialValueList = [
  {
    value: "35dx",
    label: "35DX",
  },
  {
    value: "35qx",
    label: "35QX",
  },
  {
    value: "70qx",
    label: "70QX",
  },
  {
    value: "70tx",
    label: "70TX",
  },
];

export const mediumVoltageCableTypeList = [
  {
    value: "asc",
    label: "ASC",
  },
  {
    value: "afc",
    label: "AFC",
  },
];

export const RelayTypeList = [
  {
    value: "RL",
    label: "RL",
  },
  {
    value: "PH",
    label: "PH",
  },
];

export const SwitchTypeList = [
  {
    value: "drop_fuse",
    label: "DROP FUSE",
  },
  {
    value: "disconnecting_normally",
    label: "Disconnecting normally",
  },
  {
    value: "das",
    label: "DAS",
  },
];

export const MeterTypeList = [
  {
    value: "meter1fase",
    label: "เครื่องวัด 1 เฟส",
  },
  {
    value: "meter3fase",
    label: "เครื่องวัด 3 เฟส",
  },
  {
    value: "groupmeter",
    label: "Group Meter",
  },
  {
    value: "high_tension_meter",
    label: "HT METER",
  },
];

export const MeterSizeList = [
  {
    value: "5(15)",
    label: "5(15)",
  },
  {
    value: "50(150)",
    label: "50(150)",
  },
  {
    value: "15(45)",
    label: "15(45)",
  },
  {
    value: "30(100)",
    label: "30(100)",
  },
  {
    value: "100",
    label: "100",
  },
  {
    value: "200",
    label: "200",
  },
  {
    value: "400",
    label: "400",
  },
];
